import type { UserProfile } from '@/shared/types/user.type'

export const SUPER_ADMIN_ROLE_CODE = 'SUPER_ADMIN'

type UserAccessSource = Partial<Pick<UserProfile, 'roles' | 'permissions'>> | null | undefined

export function hasRole(
  user: Partial<Pick<UserProfile, 'roles'>> | null | undefined,
  roleCode: string,
): boolean {
  return (user?.roles ?? []).some((role) => role.code === roleCode)
}

export function hasPermission(
  user: Partial<Pick<UserProfile, 'permissions'>> | null | undefined,
  permission: string,
): boolean {
  const permissions = user?.permissions ?? []

  return permissions.includes('*') || permissions.includes(permission)
}

export function hasAnyPermission(user: UserAccessSource, permissions: string[]): boolean {
  if (permissions.length === 0) {
    return true
  }

  return permissions.some((permission) => hasPermission(user, permission))
}

export function hasAllPermissions(user: UserAccessSource, permissions: string[]): boolean {
  if (permissions.length === 0) {
    return true
  }

  return permissions.every((permission) => hasPermission(user, permission))
}

export function isSuperAdmin(user: Pick<UserProfile, 'roles'> | null | undefined): boolean {
  return hasRole(user, SUPER_ADMIN_ROLE_CODE)
}
